// 앱 UI 문자열(7개 언어)을 한곳에서 관리하는 번역 테이블
export const SUPPORTED_LOCALES = ['en', 'ko', 'ja', 'zh', 'fr', 'de', 'es'];

export const LOCALE_LABELS = {
  en: 'English',
  ko: '한국어',
  ja: '日本語',
  zh: '中文',
  fr: 'Français',
  de: 'Deutsch',
  es: 'Español',
};

const en = {
  meta: { appTitle: 'Tarot Reading' },
  questionForm: {
    title: 'Get Your Free Tarot Reading!',
    placeholder: 'Type your question here...',
    submit: 'Draw Cards',
    defaultQuestion: 'What does my future hold?',
  },
  cardSelection: {
    title: 'Select 3 Cards!',
    subtitle: 'Pick one card each for Past, Present, and Future.',
    selectMore: 'Please select {count} more card(s)!',
    getInterpretation: 'Get Interpretation',
    loading: 'Generating your interpretation...',
  },
  positions: { past: 'Past', present: 'Present', future: 'Future' },
  orientation: { reversed: 'Reversed', upright: 'Upright' },
  interpretation: {
    title: 'Tarot Card Interpretation',
    questionLabel: 'Question:',
    interpretationTitle: 'Interpretation:',
    errorMessage: 'Sorry, there was an error while interpreting. Please try again.',
    loadingMessage: 'Generating interpretation...',
    newReadingButton: 'New Tarot Reading',
  },
  header: {
    language: 'Language',
    menu: 'Menu',
    soundOn: 'Turn sound on',
    soundOff: 'Turn sound off',
    navFreeTarot: 'Free Tarot Reading',
    navBlog: 'Blog',
    navAbout: 'About Us',
    navPrivacy: 'Privacy Policy',
    navTerms: 'Terms Of Service',
    navContact: 'Contact Us',
  },
  footer: {
    languageTitle: 'Language',
    menuTitle: 'Menu',
    copyright: 'Copyright © {year} Tarot Cards Reading',
  },
};

const ko = {
  meta: { appTitle: '타로 리딩' },
  questionForm: {
    title: '무료 타로 리딩을 받아보세요!',
    placeholder: '질문을 입력하세요...',
    submit: '카드 뽑기',
    defaultQuestion: '앞으로의 운세가 어떻게 될까요?',
  },
  cardSelection: {
    title: '카드 3장을 고르세요!',
    subtitle: '과거, 현재, 미래에 각각 한 장씩 골라 주세요.',
    selectMore: '카드를 {count}장 더 골라 주세요!',
    getInterpretation: '해석 보기',
    loading: '해석을 생성하는 중입니다...',
  },
  positions: { past: '과거', present: '현재', future: '미래' },
  orientation: { reversed: '역방향', upright: '정방향' },
  interpretation: {
    title: '타로 카드 해석',
    questionLabel: '질문:',
    interpretationTitle: '해석:',
    errorMessage: '해석 중 오류가 발생했습니다. 다시 시도해 주세요.',
    loadingMessage: '해석을 생성하는 중입니다...',
    newReadingButton: '새 타로 리딩',
  },
  header: {
    language: '언어',
    menu: '메뉴',
    soundOn: '소리 켜기',
    soundOff: '소리 끄기',
    navFreeTarot: '무료 타로 리딩',
    navBlog: '블로그',
    navAbout: '소개',
    navPrivacy: '개인정보 처리방침',
    navTerms: '이용약관',
    navContact: '문의',
  },
  footer: {
    languageTitle: '언어',
    menuTitle: '메뉴',
    copyright: 'Copyright © {year} Tarot Cards Reading',
  },
};

const ja = {
  meta: { appTitle: 'タロットリーディング' },
  questionForm: {
    title: '無料タロットリーディング',
    placeholder: 'ここに質問を入力...',
    submit: 'カードを引く',
    defaultQuestion: 'これからの運勢はどうなりますか？',
  },
  cardSelection: {
    title: 'カードを3枚選んでください',
    subtitle: '過去・現在・未来に、それぞれ1枚ずつ選びます。',
    selectMore: 'あと{count}枚、カードを選んでください。',
    getInterpretation: 'リーディングを見る',
    loading: 'リーディングを作成しています...',
  },
  positions: { past: '過去', present: '現在', future: '未来' },
  orientation: { reversed: '逆位置', upright: '正位置' },
  interpretation: {
    title: 'タロットカードのリーディング',
    questionLabel: '質問:',
    interpretationTitle: 'リーディング:',
    errorMessage: 'リーディング中にエラーが発生しました。もう一度お試しください。',
    loadingMessage: 'リーディングを作成しています...',
    newReadingButton: '新しいタロットリーディング',
  },
  header: {
    language: '言語',
    menu: 'メニュー',
    soundOn: '音を出す',
    soundOff: '音を消す',
    navFreeTarot: '無料タロットリーディング',
    navBlog: 'ブログ',
    navAbout: '私たちについて',
    navPrivacy: 'プライバシーポリシー',
    navTerms: '利用規約',
    navContact: 'お問い合わせ',
  },
  footer: {
    languageTitle: '言語',
    menuTitle: 'メニュー',
    copyright: 'Copyright © {year} Tarot Cards Reading',
  },
};

const zh = {
  meta: { appTitle: '塔罗牌占卜' },
  questionForm: {
    title: '免费塔罗牌占卜！',
    placeholder: '在此输入你的问题...',
    submit: '抽牌',
    defaultQuestion: '我的未来会怎样？',
  },
  cardSelection: {
    title: '请选择3张牌！',
    subtitle: '为过去、现在和未来各选一张牌。',
    selectMore: '还需要再选 {count} 张牌！',
    getInterpretation: '查看解读',
    loading: '正在生成你的解读...',
  },
  positions: { past: '过去', present: '现在', future: '未来' },
  orientation: { reversed: '逆位', upright: '正位' },
  interpretation: {
    title: '塔罗牌解读',
    questionLabel: '问题：',
    interpretationTitle: '解读：',
    errorMessage: '抱歉，解读时出现错误。请重试。',
    loadingMessage: '正在生成解读...',
    newReadingButton: '重新占卜',
  },
  header: {
    language: '语言',
    menu: '菜单',
    soundOn: '开启声音',
    soundOff: '关闭声音',
    navFreeTarot: '免费塔罗牌占卜',
    navBlog: '博客',
    navAbout: '关于我们',
    navPrivacy: '隐私政策',
    navTerms: '服务条款',
    navContact: '联系我们',
  },
  footer: {
    languageTitle: '语言',
    menuTitle: '菜单',
    copyright: 'Copyright © {year} Tarot Cards Reading',
  },
};

const fr = {
  meta: { appTitle: 'Lecture de tarot' },
  questionForm: {
    title: 'Votre tirage de tarot gratuit !',
    placeholder: 'Écrivez votre question ici...',
    submit: 'Tirer les cartes',
    defaultQuestion: 'Que me réserve l’avenir ?',
  },
  cardSelection: {
    title: 'Choisissez 3 cartes !',
    subtitle: 'Une carte pour le Passé, le Présent et l’Avenir.',
    selectMore: 'Veuillez encore choisir {count} carte(s) !',
    getInterpretation: 'Obtenir l’interprétation',
    loading: 'Génération de votre interprétation...',
  },
  positions: { past: 'Passé', present: 'Présent', future: 'Avenir' },
  orientation: { reversed: 'Renversée', upright: 'Endroit' },
  interpretation: {
    title: 'Interprétation du tirage',
    questionLabel: 'Question :',
    interpretationTitle: 'Interprétation :',
    errorMessage: 'Désolé, une erreur s’est produite. Veuillez réessayer.',
    loadingMessage: 'Génération de l’interprétation...',
    newReadingButton: 'Nouveau tirage',
  },
  header: {
    language: 'Langue',
    menu: 'Menu',
    soundOn: 'Activer le son',
    soundOff: 'Couper le son',
    navFreeTarot: 'Tirage gratuit',
    navBlog: 'Blog',
    navAbout: 'À propos',
    navPrivacy: 'Politique de confidentialité',
    navTerms: 'Conditions d’utilisation',
    navContact: 'Contact',
  },
  footer: {
    languageTitle: 'Langue',
    menuTitle: 'Menu',
    copyright: 'Copyright © {year} Tarot Cards Reading',
  },
};

const de = {
  meta: { appTitle: 'Tarot-Lesung' },
  questionForm: {
    title: 'Kostenloses Tarot-Reading!',
    placeholder: 'Schreiben Sie hier Ihre Frage...',
    submit: 'Karten ziehen',
    defaultQuestion: 'Was bringt mir die Zukunft?',
  },
  cardSelection: {
    title: 'Wählen Sie 3 Karten!',
    subtitle: 'Je eine Karte für Vergangenheit, Gegenwart und Zukunft.',
    selectMore: 'Bitte wählen Sie noch {count} Karte(n)!',
    getInterpretation: 'Deutung anzeigen',
    loading: 'Ihre Deutung wird erstellt...',
  },
  positions: { past: 'Vergangenheit', present: 'Gegenwart', future: 'Zukunft' },
  orientation: { reversed: 'Umgekehrt', upright: 'Aufrecht' },
  interpretation: {
    title: 'Tarot-Deutung',
    questionLabel: 'Frage:',
    interpretationTitle: 'Deutung:',
    errorMessage: 'Bei der Deutung ist ein Fehler aufgetreten. Bitte erneut versuchen.',
    loadingMessage: 'Deutung wird erstellt...',
    newReadingButton: 'Neues Tarot-Reading',
  },
  header: {
    language: 'Sprache',
    menu: 'Menü',
    soundOn: 'Ton einschalten',
    soundOff: 'Ton ausschalten',
    navFreeTarot: 'Kostenloses Tarot-Reading',
    navBlog: 'Blog',
    navAbout: 'Über uns',
    navPrivacy: 'Datenschutz',
    navTerms: 'Nutzungsbedingungen',
    navContact: 'Kontakt',
  },
  footer: {
    languageTitle: 'Sprache',
    menuTitle: 'Menü',
    copyright: 'Copyright © {year} Tarot Cards Reading',
  },
};

const es = {
  meta: { appTitle: 'Lectura de tarot' },
  questionForm: {
    title: '¡Tu lectura de tarot gratuita!',
    placeholder: 'Escribe tu pregunta aquí...',
    submit: 'Sacar cartas',
    defaultQuestion: '¿Qué me depara el futuro?',
  },
  cardSelection: {
    title: '¡Elige 3 cartas!',
    subtitle: 'Una carta para el Pasado, el Presente y el Futuro.',
    selectMore: '¡Por favor elige {count} carta(s) más!',
    getInterpretation: 'Ver interpretación',
    loading: 'Generando tu interpretación...',
  },
  positions: { past: 'Pasado', present: 'Presente', future: 'Futuro' },
  orientation: { reversed: 'Invertida', upright: 'Derecha' },
  interpretation: {
    title: 'Interpretación del tarot',
    questionLabel: 'Pregunta:',
    interpretationTitle: 'Interpretación:',
    errorMessage: 'Hubo un error al interpretar. Inténtalo de nuevo.',
    loadingMessage: 'Generando interpretación...',
    newReadingButton: 'Nueva lectura',
  },
  header: {
    language: 'Idioma',
    menu: 'Menú',
    soundOn: 'Activar sonido',
    soundOff: 'Silenciar',
    navFreeTarot: 'Lectura gratuita de tarot',
    navBlog: 'Blog',
    navAbout: 'Sobre nosotros',
    navPrivacy: 'Política de privacidad',
    navTerms: 'Términos del servicio',
    navContact: 'Contacto',
  },
  footer: {
    languageTitle: 'Idioma',
    menuTitle: 'Menú',
    copyright: 'Copyright © {year} Tarot Cards Reading',
  },
};

export const translations = { en, ko, ja, zh, fr, de, es };
